import styled from 'styled-components'

import FeatureTourForm from 'pages/shared/FeatureTourForm'
import FeatureTour from 'models/FeatureTour'

import { PageHeader, PageTitle, SinglePanePage, screenSize } from 'styles/shared'

const AddFeatureTour = () => (
  <>
    <PageHeader>
      <S.PageTitle>New Feature Tour</S.PageTitle>
    </PageHeader>
    <S.SinglePanePage>
      <FeatureTourForm
        featureTour={new FeatureTour()}
        validatedSaveType="create"
      />
    </S.SinglePanePage>
  </>
)

export default AddFeatureTour

const S = {
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0;
    }
  `,
  PageTitle: styled(PageTitle)`
    @media ${screenSize.small} {
      display: block;
    }
  `
}
